module.exports = __webpack_public_path__ + "static/head-pic3-40702bfd355761f420fb404e3a5f91cf.png";